import { render, staticRenderFns } from "./pudo-manager.vue?vue&type=template&id=0dd8b2f5"
import script from "./pudo-manager.vue?vue&type=script&lang=js"
export * from "./pudo-manager.vue?vue&type=script&lang=js"
import style0 from "./pudo-manager.vue?vue&type=style&index=0&id=0dd8b2f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports